module.exports = "/_next/static/assets/img/smavagmbh-436f78fd4a1be8ea5abc261f8db717ba.jpg";